import React, { useState } from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Phone, Mail, Send, Edit, Loader2 } from 'lucide-react';

export default function SignatureMethodSelector({ identite, signingInProgress, signatureMethod: signatureMethod, handleInitiateSignature, reference }) {
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [customPhone, setCustomPhone] = useState(identite.telephone || '');
  const [customEmail, setCustomEmail] = useState(identite.email || '');

  if (!selectedMethod) {
    return (
      <div className="space-y-3">
        <p className="text-sm text-gray-500 text-center">Choisissez votre methode de signature :</p>
        <div className="grid grid-cols-2 gap-3">
          <Button
            onClick={() => { setSelectedMethod('sms'); setCustomPhone(identite.telephone || ''); }}
            variant="outline"
            className="h-16 flex flex-col items-center gap-1.5 border-2 border-purple-200 hover:bg-purple-50 hover:border-purple-400 transition-all"
            data-testid="btn-select-sms"
          >
            <Phone className="h-5 w-5 text-purple-600" />
            <span className="text-sm font-semibold text-purple-700">Signature par SMS</span>
          </Button>
          <Button
            onClick={() => { setSelectedMethod('email'); setCustomEmail(identite.email || ''); }}
            variant="outline"
            className="h-16 flex flex-col items-center gap-1.5 border-2 border-indigo-200 hover:bg-indigo-50 hover:border-indigo-400 transition-all"
            data-testid="btn-select-email"
          >
            <Mail className="h-5 w-5 text-indigo-600" />
            <span className="text-sm font-semibold text-indigo-700">Signature par Email</span>
          </Button>
        </div>
      </div>
    );
  }

  const isSms = selectedMethod === 'sms';
  const destination = isSms ? customPhone : customEmail;
  const isValid = isSms ? customPhone.length >= 10 : customEmail.includes('@');

  return (
    <div className="space-y-4">
      <div className="p-4 rounded-lg border-2 border-dashed" style={{ borderColor: isSms ? '#9333ea' : '#6366f1' }}>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            {isSms ? <Phone className="h-4 w-4 text-purple-600" /> : <Mail className="h-4 w-4 text-indigo-600" />}
            <span className="text-sm font-semibold" style={{ color: isSms ? '#7e22ce' : '#4338ca' }}>
              {isSms ? 'Signature par SMS' : 'Signature par Email'}
            </span>
          </div>
          <Button variant="ghost" size="sm" className="text-xs text-gray-400 h-7 px-2" onClick={() => setSelectedMethod(null)} data-testid="btn-change-method">
            <Edit className="h-3 w-3 mr-1" />
            Changer
          </Button>
        </div>
        <div className="space-y-2">
          <Label className="text-xs text-gray-600">
            {isSms ? 'Numero de telephone pour recevoir le code' : 'Adresse email pour recevoir le code'}
          </Label>
          <div className="flex gap-2">
            <Input
              type={isSms ? 'tel' : 'email'}
              value={destination}
              onChange={(e) => isSms ? setCustomPhone(e.target.value) : setCustomEmail(e.target.value)}
              placeholder={isSms ? '06 90 12 34 56' : 'votre@email.com'}
              className="flex-1"
              data-testid={isSms ? 'input-custom-phone' : 'input-custom-email'}
            />
            <Button
              onClick={() => handleInitiateSignature(reference, selectedMethod, destination)}
              disabled={signingInProgress || !isValid}
              className={isSms ? 'bg-purple-600 hover:bg-purple-700' : 'bg-indigo-600 hover:bg-indigo-700'}
              data-testid="btn-send-code"
            >
              {signingInProgress ? (
                <Loader2 className="h-4 w-4 animate-spin mr-2" />
              ) : (
                <Send className="h-4 w-4 mr-2" />
              )}
              Envoyer le code
            </Button>
          </div>
          {isSms && (
            <p className="text-[10px] text-gray-400">Format: 06 XX XX XX XX ou +33 6 XX XX XX XX</p>
          )}
        </div>
      </div>
    </div>
  );
}
